export const Account = {
    currentUser: null
};


// WEBPACK FOOTER //
// ./src/js/Xola/services/Account.js